// 利润保护表单的草稿与换算（决策 D70，docs/04 第 2 节）。维度只在新建时填，编辑只改上限、备注与启停。
import type { Errors } from "@/app/useDraft";
import { formatMoneyInput, parseMoney, validMcc, validMnc } from "@/app/form";
import type { EntityStatus, ProfitGuard, ProfitGuardInput } from "@/app/master";

export interface ProfitGuardDraft { account_id: string; mcc: string; mnc: string; loss_limit: string; status: EntityStatus; note: string }

export function profitGuardDraft(row?: ProfitGuard): ProfitGuardDraft {
  return row
    ? { account_id: String(row.account_id), mcc: row.mcc, mnc: row.mnc ?? "", loss_limit: formatMoneyInput(row.loss_limit), status: row.status, note: row.note ?? "" }
    : { account_id: "", mcc: "", mnc: "", loss_limit: "", status: "active", note: "" };
}

/** 校验并换算；MNC 留空表示该 MCC 全部运营商。 */
export function profitGuardInput(d: ProfitGuardDraft): { body?: ProfitGuardInput; errors: Errors<ProfitGuardDraft> } {
  const errors: Errors<ProfitGuardDraft> = {};
  const limit = parseMoney(d.loss_limit);
  if (!d.account_id) errors.account_id = "选择账号。";
  if (!validMcc(d.mcc)) errors.mcc = "三位数字，例如 510。";
  if (d.mnc && !validMnc(d.mnc)) errors.mnc = "两到三位数字，留空表示全部运营商。";
  if (limit === null || limit <= 0) errors.loss_limit = "大于 0 的金额，最多 6 位小数。";
  if (Object.keys(errors).length) return { errors };
  return { errors, body: { account_id: Number(d.account_id), mcc: d.mcc, mnc: d.mnc || null, loss_limit: limit!, status: d.status, note: d.note.trim() || null } };
}

/** 列表与标题里的维度：MCC-MNC，没有 MNC 时写明全部运营商。 */
export function guardScope(g: Pick<ProfitGuard, "mcc" | "mnc">): string {
  return g.mnc ? `${g.mcc}-${g.mnc}` : `${g.mcc} 全部运营商`;
}
